import PassportRecordRequirementReviewerTable from "./PassportRecordRequirementReviewerTable";

export default PassportRecordRequirementReviewerTable;